import image_1 from "../images/afro-solar/solar-pump/bg-1.webp";

const SolarPump = () => {
  return (
    <div className="container-fluid pt-7">
      <div className="me-13 ms-13 pt-7">
        <div className="row">
          <h2 className="fs-56 lh-64 gilroy-bold">
            SOLAR <span className="text-orange-ryb">PUMP</span>
          </h2>
          <h3 className="text-orange-ryb fs-18 gilroy-bold pb-4">
            Transforming the Rural Landscape
          </h3>
          <div className="col-12 col-sm-12 col-md-12 col-lg-6 bg-white order-1 order-lg-0 pe-lg-5">
            <div className="pe-lg-5">
              <p className="fs-16 lh-30 text-align-justify">
                By switching to Afro Solar Water Pumps, farmers can have access
                to a highly-efficient power supply that can be used throughout
                the day to provide a consistent water supply.
              </p>
              <p className="fs-16 lh-30 text-align-justify">
                Afro invites National & Local Governments to sponsor & fund
                flagship Government program to farmers in their countries.
              </p>

              <h2 className="fs-22 gilroy-bold my-4">
                Water Pumps in both Surface &Submersible categories.
              </h2>
              <p className="fs-16 lh-30 text-align-justify">
                The agriculture sector in Africa are heavily dependent on rain
                for natural irrigation. Pumps are used as an artificial means to
                provide water for irrigation. Farmers rely on grid electricity
                or diesel gen-sets to run the pump, which leads to huge delays
                and economic stress. Hence, for our farmers, an effective
                irrigation system such as the Solar Water Pump is a great
                advantage. It increases their crop yield by ensuring a reliable
                and perennial supply of water to their fields.
              </p>
              <p className="fs-16 lh-30 text-align-justify">
                A solar water pump is an application of photovoltaic technology
                which converts solar energy into electricity to run the pumping
                system thereby, replacing erratic grid supply and
                pollution-causing diesel-powered versions. solar water pump
                powered by solar modules helps draw surface or ground water out
                for irrigation.
              </p>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-6 bg-white order-0 order-lg-1 pb-5 pb-lg-0">
            <img
              src={image_1}
              loading="lazy"
              className="img-fluid rounded"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolarPump;
